module.exports = __webpack_public_path__ + "static/media/kitchen.e9dfa00a.svg";